
export { DeviceProvider } from "/opt/render/project/src/src/contexts/device/index.tsx"
export { OddsViewProvider } from "/opt/render/project/src/src/contexts/oddsView/index.tsx"